import { TExamLabelType } from 'app.type/examLabelType';

export const ExamTypeLabels: Record<TExamLabelType, string> = {
  PAST: '기출',
  EXPECTED: '예상기출',
  PAST_VARIATION: '기출변형',
};
